import React from "react";
import { Box } from "./style";
import Button from "../../../../components/button";

const Error = props => {
    return (
    <Box>
      <div className="notfound">
        <div className="notfound-404">
          <h1>خطا</h1>
        </div>
        <p>{props.message}</p>
        <Button
          btn="primary"
          onClick={() => {
            window.location.reload();
          }}
        >
          بارگذاری مجدد
        </Button>
      </div>
    </Box>
  );
};
export default Error;
